// AFO product page (product-page feature).
// <afo-product-nav>: sticky bölüm nav'ı — scroll-spy aktif nokta + smooth scroll
// + doğal konumu geçince fixed kilitlenme. Morph/section-render'a dayanıklı.
// No globals; sessionStorage anahtarı koleksiyonla ortak (toggle Step 10'da eklenir).

const HEADER_OFFSET = 121; // ICW blueprint: scroll sonrası nav top
const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!customElements.get('afo-product-nav')) {
  customElements.define(
    'afo-product-nav',
    class AfoProductNav extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('[data-afo-nav]')];
        this.resolveTargets();
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        // r21: JS-fixed taklidi hızlı scroll'da kaçınılmaz zıplatıyordu →
        // GERÇEK position:sticky. Sticky ebeveyn yüksekliğiyle sınırlı olduğundan
        // nav, tam sayfa boyunda absolute bir RAYA taşınır (compositor-pürüzsüz).
        if (window.matchMedia('(min-width: 750px)').matches) this.mountRail();
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      mountRail() {
        if (this.closest('.afo-pp-rail')) return;
        // morph re-render yeni bir nav üretir — eski ray/iz temizlenir, yenisi devralır
        document.querySelectorAll('.afo-pp-rail, .afo-pp-nav-slot').forEach((e) => e.remove());
        // orijinal yuvada ölçüm için iz bırak (resize'da ray yeniden konumlanır)
        this.placeholder = document.createElement('span');
        this.placeholder.className = 'afo-pp-nav-slot';
        this.parentElement.insertBefore(this.placeholder, this);
        this.rail = document.createElement('div');
        this.rail.className = 'afo-pp-rail';
        document.body.appendChild(this.rail);
        this.rail.appendChild(this);
        this.positionRail();
        // görseller/fontlar otururken ray kaymasın: yükleme sonrası yeniden ölç
        window.addEventListener('load', () => this.positionRail(), { once: true });
        setTimeout(() => this.positionRail(), 1500);
      }

      positionRail() {
        if (!this.rail || !this.placeholder.isConnected) return;
        const slot = this.placeholder.getBoundingClientRect();
        const top = slot.top + window.scrollY;
        const endEl = document.querySelector('.product-recommendations')?.closest('.shopify-section')
          || document.getElementById('afo-care');
        const bottom = endEl ? endEl.getBoundingClientRect().bottom + window.scrollY : top + 2000;
        this.rail.style.top = `${top}px`;
        this.rail.style.left = `${slot.left}px`;
        this.rail.style.height = `${Math.max(0, bottom - top)}px`;
        // ray genişliği = nav'ın eski kolonu (aksiyon kolonu sıkışmasın — r22)
        const colW = this.placeholder.parentElement.getBoundingClientRect().width;
        this.rail.style.width = `${colW}px`;
      }

      resolveTargets() {
        this.targets = {};
        for (const link of this.links) {
          const key = link.dataset.afoNav;
          let el = document.getElementById(key);
          if (!el && key === 'afo-overview') {
            el = document.querySelector('.product-information')?.closest('.shopify-section') || null;
          }
          if (!el && key === 'afo-explore') {
            el = document.querySelector('product-recommendations')?.closest('.shopify-section') || null;
          }
          if (el) this.targets[key] = el;
          else link.parentElement.style.display = 'none';
        }
      }

      onResize() {
        this.positionRail();
        this.onScroll();
      }

      onScroll() {
        // pinned kozmetiği: yapışıkken aksiyon kolonu gizlenir (ICW)
        const pinned = this.rail && this.getBoundingClientRect().top <= 122;
        this.classList.toggle('is-pinned', !!pinned);
        // scroll-spy
        let active = null;
        let best = -Infinity;
        for (const [key, el] of Object.entries(this.targets)) {
          const top = el.getBoundingClientRect().top;
          if (top <= 201 && top > best) {
            best = top;
            active = key;
          }
        }
        if (!active) active = 'afo-overview';
        if (active !== this.active) {
          this.active = active;
          this.links.forEach((l) => l.classList.toggle('is-active', l.dataset.afoNav === active));
        }
      }

      onClick(event) {
        const link = event.target.closest('[data-afo-nav]');
        if (!link) return;
        const el = this.targets[link.dataset.afoNav];
        if (!el) return;
        event.preventDefault();
        const top = el.getBoundingClientRect().top + window.scrollY - 81;
        window.scrollTo({ top, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }
    },
  );
}

// ---------- galeri light on/off (koleksiyonla ortak konvansiyon + state) ----------
const LIGHTS_KEY = 'afo-lights-on'; // koleksiyon toggle'ıyla AYNI anahtar

if (!customElements.get('afo-gallery-toggle')) {
  customElements.define(
    'afo-gallery-toggle',
    class AfoGalleryToggle extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || document;
        this.setup();
        // morph/section-render süpürmesine karşı: galeri yeniden kurulursa tekrar kur
        this.observer = new MutationObserver(() => {
          if (!this.section.querySelector('.afo-pp-light')) queueMicrotask(() => this.setup());
        });
        this.observer.observe(this.section, { childList: true, subtree: true });
      }
      disconnectedCallback() { this.observer?.disconnect(); }

      setup() {
        const gallery = this.section.querySelector('[class*="media-gallery"]');
        if (!gallery) return;
        const onImgs = [...gallery.querySelectorAll('img[alt*="#on"]')];
        if (!onImgs.length) return;

        // #on slaytlarını karuselden gizle (çift görünmesin)
        // r30: EN DIŞ slayt kabuğu gizlenmeli — product-media gizlenince
        // slideshow-slide 650px boş kutu olarak kalıyordu (boş 2. görsel)
        for (const img of onImgs) {
          const slide = img.closest('slideshow-slide') || img.closest('li') || img.closest('.product-media');
          if (slide && !slide.classList.contains('afo-slide-hidden')) slide.classList.add('afo-slide-hidden');
        }

        // ilk (off) slayta overlay bindir — r31.10: gizlenen kabuk slideshow-slide olduğu için
        // '.product-media:not(.afo-slide-hidden)' #on slaytın kendisini seçiyordu (overlay 0×0 kalıyordu);
        // artık gizli kabuğun içinde olmayan ve #on olmayan ilk slayt seçilir
        const firstMedia = [...gallery.querySelectorAll('.product-media')].find((m) => {
          if (m.classList.contains('afo-slide-hidden') || m.closest('.afo-slide-hidden')) return false;
          const im = m.querySelector('img');
          return !(im && (im.getAttribute('alt') || '').includes('#on'));
        });
        if (firstMedia && !firstMedia.querySelector('.afo-on-overlay')) {
          const ov = document.createElement('img');
          ov.className = 'afo-on-overlay';
          ov.alt = '';
          ov.src = onImgs[0].currentSrc || onImgs[0].src;
          if (onImgs[0].srcset) ov.srcset = onImgs[0].srcset;
          if (onImgs[0].sizes) ov.sizes = onImgs[0].sizes;
          firstMedia.style.position = 'relative';
          firstMedia.appendChild(ov);
        }

        // toggle butonu
        if (!gallery.querySelector('.afo-pp-light')) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'afo-pp-light';
          btn.innerHTML = '<span>Light</span><span class="afo-pp-light__track"><span class="afo-pp-light__knob"></span></span>';
          btn.addEventListener('click', () => this.toggle());
          const host = gallery.querySelector('.media-gallery--carousel') || gallery;
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          host.appendChild(btn);
          this.button = btn;
        }
        this.applyState();
      }

      toggle() {
        const on = !(sessionStorage.getItem(LIGHTS_KEY) === 'true');
        sessionStorage.setItem(LIGHTS_KEY, String(on));
        this.applyState();
      }

      applyState() {
        const on = sessionStorage.getItem(LIGHTS_KEY) === 'true';
        document.documentElement.classList.toggle('afo-lights-on', on);
        this.section.querySelectorAll('.afo-pp-light').forEach((b) => b.setAttribute('aria-pressed', String(on)));
      }
    },
  );
}

// ---------- Explore (mobil): sağa kaydırma oku (r48) ----------
(() => {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  const mount = () => {
    const list = document.querySelector('.product-recommendations .resource-list');
    if (!list || list.children.length < 2) return false; // skeleton/boş — bekle
    if (list.parentElement.querySelector('.afo-rec-arrow')) return true;
    const host = list.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    const mk = (dir) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `afo-rec-arrow${dir < 0 ? ' afo-rec-arrow--left' : ''}`;
      btn.setAttribute('aria-label', dir < 0 ? 'Scroll left' : 'Scroll right');
      btn.addEventListener('click', () => list.scrollBy({ left: dir * list.clientWidth * 0.7, behavior: 'smooth' }));
      host.appendChild(btn);
      return btn;
    };
    const next = mk(1);
    const prev = mk(-1);
    const sync = () => {
      next.classList.toggle('is-hidden', list.scrollLeft + list.clientWidth >= list.scrollWidth - 10);
      prev.classList.toggle('is-hidden', list.scrollLeft <= 10);
      // r55: ok, kart GÖRSELİNİN dikey ortasında (başlık/fiyat alanı hariç)
      const img = list.querySelector('img');
      if (img) {
        const top = img.getBoundingClientRect().top - host.getBoundingClientRect().top + img.getBoundingClientRect().height / 2 - 20;
        if (top > 0) { next.style.top = `${Math.round(top)}px`; prev.style.top = `${Math.round(top)}px`; }
      }
    };
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
    return true;
  };
  // öneriler async yüklenir (skeleton → içerik değişimi oku siler) — KALICI izle (r48)
  const section = document.querySelector('.product-recommendations');
  if (!section) return;
  mount();
  new MutationObserver(() => queueMicrotask(() => mount())).observe(section, { childList: true, subtree: true });
})();

// ---------- ana galeri (mobil): kaydırma tamamen kapalı — yalnız ilk görsel (n11/r49) ----------
// CSS overflow kilidi vendor'un JS pointer-sürüklemesini durdurmaz; bileşenin kendi
// mobile-disabled guard'ı kullanılır (viewport ayrımı vendor'da). Morph silerse geri yazılır.
(() => {
  const lock = () => {
    document
      .querySelectorAll('.product-information__media slideshow-container:not([mobile-disabled])')
      .forEach((el) => el.setAttribute('mobile-disabled', ''));
    if (window.matchMedia('(max-width: 749px)').matches) {
      // birikmiş offset kalmasın — mobilde her zaman ilk slayt
      document.querySelectorAll('.product-information__media slideshow-slides').forEach((el) => {
        if (el.scrollLeft) el.scrollLeft = 0;
      });
    }
  };
  lock();
  new MutationObserver(() => queueMicrotask(lock)).observe(document.body, { childList: true, subtree: true });
})();

// marker varsa (ayar açık) toggle'ı ürün section'ına tak
if (document.querySelector('[data-afo-pp-toggle]') && document.querySelector('.product-information')) {
  const sectionEl = document.querySelector('.product-information').closest('.shopify-section');
  if (sectionEl && !sectionEl.querySelector('afo-gallery-toggle')) {
    sectionEl.appendChild(document.createElement('afo-gallery-toggle'));
  }
}

// ---------- ICW custom dropdown (varyant satırları) ----------
const AFO_SWATCH_COLORS = {
  'aged brass': '#4d3b25',
  'raw brass': '#88753e',
  'blackened brass': '#2d2924',
  'off-white painted': '#EAE5DB',
  'off white painted': '#EAE5DB',
};
const afoDotHtml = (name) => {
  const c = AFO_SWATCH_COLORS[(name || '').toLowerCase()];
  return c ? `<span class="afo-dd-dot" style="background:${c}"></span>` : '';
};

function afoEnhanceDropdowns(root) {
  root.querySelectorAll('.variant-option--dropdowns:not(.afo-dd-enhanced)').forEach((row) => {
    const select = row.querySelector('select');
    if (!select) return;
    row.classList.add('afo-dd-enhanced');

    const current = () => {
      const o = select.selectedOptions[0];
      return o ? o.text.replace(/\s*-\s*Unavailable\s*$/i, '').trim() : '';
    };

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'afo-dd-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = `<span class="afo-dd-value">${current()}</span><span class="afo-dd-right">${afoDotHtml(current())}<span class="afo-dd-caret" aria-hidden="true"></span></span>`;
    select.parentElement.appendChild(trigger);

    const panel = document.createElement('div');
    panel.className = 'afo-dd-panel';
    panel.setAttribute('role', 'listbox');
    const head = document.createElement('button');
    head.type = 'button';
    head.className = 'afo-dd-panel__head';
    head.innerHTML = `<span>${current()}</span><span class="afo-dd-right">${afoDotHtml(current())}<span class="afo-dd-caret" aria-hidden="true"></span></span>`;
    panel.appendChild(head);
    for (const opt of select.options) {
      const clean = opt.text.replace(/\s*-\s*Unavailable\s*$/i, '').trim();
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'afo-dd-panel__opt';
      b.setAttribute('role', 'option');
      b.dataset.value = opt.value;
      const color = AFO_SWATCH_COLORS[clean.toLowerCase()];
      b.innerHTML = `<span>${clean}</span>${color ? `<span class="afo-dd-dot" style="background:${color}"></span>` : ''}`;
      b.addEventListener('click', () => {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        trigger.querySelector('.afo-dd-value').textContent = clean;
        trigger.querySelector('.afo-dd-right').innerHTML = `${afoDotHtml(clean)}<span class="afo-dd-caret" aria-hidden="true"></span>`;
        head.querySelector('span').textContent = clean;
        head.querySelector('.afo-dd-right').innerHTML = `${afoDotHtml(clean)}<span class="afo-dd-caret" aria-hidden="true"></span>`;
        close();
      });
      panel.appendChild(b);
    }
    row.appendChild(panel);

    const close = () => { row.classList.remove('afo-dd-open'); trigger.setAttribute('aria-expanded', 'false'); };
    const open = () => {
      document.querySelectorAll('.variant-option--dropdowns.afo-dd-open').forEach((r) => r.classList.remove('afo-dd-open'));
      row.classList.add('afo-dd-open');
      trigger.setAttribute('aria-expanded', 'true');
      // panelde SEÇİLİ olan gizlenir (başlıkta zaten görünüyor — ICW)
      panel.querySelectorAll('.afo-dd-panel__opt').forEach((o) => {
        o.style.display = o.dataset.value === select.value ? 'none' : '';
      });
    };
    trigger.addEventListener('click', () => (row.classList.contains('afo-dd-open') ? close() : open()));
    // satır etiketine tıklamak da aç/kapat (r48: label'a tıklayınca kapanmıyordu)
    const rowLabel = row.querySelector(':scope > label');
    rowLabel?.addEventListener('click', (e) => {
      e.preventDefault();
      row.classList.contains('afo-dd-open') ? close() : open();
    });
    head.addEventListener('click', close);
    document.addEventListener('click', (e) => { if (!row.contains(e.target)) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  });
}

if (document.querySelector('.product-information')) {
  const sectionEl = document.querySelector('.product-information').closest('.shopify-section');
  afoEnhanceDropdowns(sectionEl);
  // morph re-render sonrası yeniden kur (satırlar yeniden yazılır)
  new MutationObserver(() => queueMicrotask(() => afoEnhanceDropdowns(sectionEl)))
    .observe(sectionEl, { childList: true, subtree: true });
}

// ---------- AFO lightbox slider — film şeridi (Collections panel deseni):
// aktif görsel solda, sonrakiler sağdan taşarak görünür; uçlarda oklar soluk.
function afoLightboxUrls() {
  const imgs = [...document.querySelectorAll('.product-information__media .product-media img:not(.afo-on-overlay), .afo-pp-fig img')].filter((i) => i.offsetParent && !i.closest('.afo-slide-hidden'));
  const seen = new Set();
  return imgs.map((img) => {
    const base = (img.currentSrc || img.src).split('&width=')[0].split('?width=')[0];
    const sep = base.includes('?') ? '&' : '?';
    return { url: `${base}${sep}width=2000`, key: base, alt: img.alt.replace(/#\w+/g, '').trim() };
  }).filter((o) => (seen.has(o.key) ? false : seen.add(o.key)));
}

function afoEnsureLightbox() {
  let lb = document.querySelector('.afo-lb');
  if (lb) return lb;
  lb = document.createElement('div');
  lb.className = 'afo-lb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.innerHTML = `
    <div class="afo-lb__stage">
      <div class="afo-lb__track"></div>
      <button type="button" class="afo-lb__close" aria-label="Close">&#10005;</button>
      <button type="button" class="afo-lb__arrow afo-lb__arrow--prev" aria-label="Previous"></button>
      <button type="button" class="afo-lb__arrow afo-lb__arrow--next" aria-label="Next"></button>
      <span class="afo-lb__caption"></span>
      <span class="afo-lb__count"></span>
      <ol class="afo-lb__dots" aria-hidden="true"></ol>
    </div>`;
  document.body.appendChild(lb);

  const track = lb.querySelector('.afo-lb__track');
  const dotsEl = lb.querySelector('.afo-lb__dots');
  const state = { items: [], i: 0 };

  const update = () => {
    const slides = [...track.children];
    if (!slides.length) return;
    const target = slides[state.i];
    // offsetLeft, track padding'ini içerir — ilk slaytın konumunu taban al ki
    // sol padding (sayfa marjı) korunarak kaydırılsın
    const base = slides[0].offsetLeft;
    let x = target.offsetLeft - base;
    // r16: sona kaydırınca sağda dev boşluk kalmasın — kaydırma, son slayt
    // sağ kenara (40px marjla) dayandığında durur
    const maxX = Math.max(0, track.scrollWidth - lb.clientWidth + 40);
    if (x > maxX) x = maxX;
    track.style.transform = `translateX(${-x}px)`;
    lb.querySelector('.afo-lb__count').textContent = `${state.i + 1} / ${state.items.length}`;
    lb.querySelector('.afo-lb__caption').textContent = state.items[state.i].alt;
    lb.querySelector('.afo-lb__arrow--prev').classList.toggle('is-dim', state.i === 0);
    lb.querySelector('.afo-lb__arrow--next').classList.toggle('is-dim', state.i === state.items.length - 1);
    slides.forEach((s, k) => s.classList.toggle('is-active', k === state.i));
    [...dotsEl.children].forEach((d, k) => d.classList.toggle('is-active', k === state.i));
  };
  const go = (i) => { state.i = Math.max(0, Math.min(state.items.length - 1, i)); update(); };

  lb.afoOpen = (startUrl) => {
    state.items = afoLightboxUrls();
    if (!state.items.length) return;
    track.innerHTML = '';
    state.items.forEach((item, k) => {
      const slide = document.createElement('figure');
      slide.className = 'afo-lb__slide';
      const im = document.createElement('img');
      im.src = item.url;
      im.alt = item.alt;
      im.addEventListener('load', update, { once: true });
      slide.appendChild(im);
      slide.addEventListener('click', () => { if (k !== state.i) go(k); });
      track.appendChild(slide);
    });
    dotsEl.innerHTML = '';
    state.items.forEach((_, k) => {
      const li = document.createElement('li');
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.addEventListener('click', (e) => { e.stopPropagation(); go(k); });
      li.appendChild(dot);
      dotsEl.appendChild(li);
    });
    const baseKey = startUrl ? startUrl.split('&width=')[0].split('?width=')[0] : '';
    const idx = Math.max(0, state.items.findIndex((o) => o.key === baseKey));
    state.i = idx;
    lb.classList.add('is-open');
    document.documentElement.classList.add('afo-lb-open');
    requestAnimationFrame(update);
    lb.querySelector('.afo-lb__close').focus();
  };
  const close = () => {
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('afo-lb-open');
  };
  lb.querySelector('.afo-lb__close').addEventListener('click', close);
  lb.querySelector('.afo-lb__arrow--prev').addEventListener('click', () => go(state.i - 1));
  lb.querySelector('.afo-lb__arrow--next').addEventListener('click', () => go(state.i + 1));
  lb.addEventListener('click', (e) => { if (e.target === lb || e.target.classList.contains('afo-lb__stage') || e.target.classList.contains('afo-lb__track')) close(); });
  document.addEventListener('keydown', (e) => {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') go(state.i - 1);
    if (e.key === 'ArrowRight') go(state.i + 1);
  });
  window.addEventListener('resize', update);
  // dokunmatik kaydırma (telefon testi 2026-09-07): yatay swipe → slayt geçişi
  let touchX = 0;
  let touchY = 0;
  lb.addEventListener('touchstart', (e) => {
    touchX = e.touches[0].clientX;
    touchY = e.touches[0].clientY;
  }, { passive: true });
  lb.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - touchX;
    const dy = e.changedTouches[0].clientY - touchY;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) go(state.i + (dx < 0 ? 1 : -1));
  }, { passive: true });
  // tekerlek/trackpad ile kaydırma (r14): birikimli eşik → slayt geçişi
  let wheelAcc = 0;
  let wheelTimer = null;
  lb.addEventListener('wheel', (e) => {
    if (!lb.classList.contains('is-open')) return;
    e.preventDefault();
    const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    wheelAcc += d;
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => { wheelAcc = 0; }, 200);
    if (wheelAcc > 90) { wheelAcc = 0; go(state.i + 1); }
    else if (wheelAcc < -90) { wheelAcc = 0; go(state.i - 1); }
  }, { passive: false });
  return lb;
}

document.addEventListener('click', (e) => {
  const img = e.target.closest('.product-information__media .product-media img, .afo-pp-fig img');
  if (!img) return;
  if (e.target.closest('.afo-pp-light')) return;
  e.preventDefault();
  afoEnsureLightbox().afoOpen(img.currentSrc || img.src);
});

// NOT (2026-09-07): mobil galeri swipe'ı için JS gerekmedi — n11/r50 tek-görsel
// kilidi afo-product.css'ten kaldırılınca vendor'ın native scroll-snap karuseli
// geri geldi (dokunma kaydırması tarayıcının kendi mekanizması).

// ---------- galeri noktaları: iOS-güvenli aktiflik senkronu (07.09) ----------
// Vendor işareti scrollend'e bağlı görünüyor; iOS Safari scrollend bilmez →
// momentum kaydırmada nokta "dolup siliniyor". Debounce'lu scroll dinleyicisiyle
// aktif indexi kendimiz işaretliyoruz (.afo-dot-on) — vendor'dan bağımsız.
(() => {
  const track = document.querySelector('.product-information__media slideshow-slides');
  const dots = document.querySelector('.product-information__media .slideshow-controls__dots');
  if (!track || !dots) return;
  let bekle;
  const sync = () => {
    // görünen slayt = scrollLeft'e en yakın offsetLeft'li slayt (gap/peek payından bağımsız)
    const slides = [...track.querySelectorAll('slideshow-slide')];
    if (!slides.length) return;
    let i = 0;
    slides.forEach((s, k) => {
      if (Math.abs(s.offsetLeft - track.scrollLeft) < Math.abs(slides[i].offsetLeft - track.scrollLeft)) i = k;
    });
    [...dots.children].forEach((li, k) => li.classList.toggle('afo-dot-on', k === i));
  };
  track.addEventListener('scroll', () => { clearTimeout(bekle); bekle = setTimeout(sync, 90); }, { passive: true });
  sync();
})();

// ---------- galeri: dikey tekerlek carousel'i ilerletir (r15) ----------
// uçlardayken sayfa scroll'una geri bırakır — sayfa kilitlenmez
(() => {
  let acc = 0;
  let cooldownUntil = 0;
  let accTimer = null;
  const slideIndex = (media) => {
    const slides = [...media.querySelectorAll('.product-media:not(.afo-slide-hidden)')];
    if (!slides.length) return { i: 0, n: 0 };
    const left = media.getBoundingClientRect().left;
    let best = 0;
    let bestD = Infinity;
    slides.forEach((s, k) => {
      const d = Math.abs(s.getBoundingClientRect().left - left);
      if (d < bestD) { bestD = d; best = k; }
    });
    return { i: best, n: slides.length };
  };
  document.addEventListener('wheel', (e) => {
    if (document.querySelector('.afo-lb.is-open')) return; // lightbox kendi tekerleğini yönetir
    const media = e.target.closest('.product-information__media');
    if (!media) return;
    const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    const { i, n } = slideIndex(media);
    if (n < 2) return;
    const atEnd = d > 0 && i >= n - 1;
    const atStart = d < 0 && i <= 0;
    if (atEnd || atStart) return; // sayfa scroll'una bırak
    e.preventDefault();
    if (Date.now() < cooldownUntil) return;
    acc += d;
    clearTimeout(accTimer);
    accTimer = setTimeout(() => { acc = 0; }, 200);
    if (Math.abs(acc) > 60) {
      const btn = media.querySelector(acc > 0 ? '.slideshow-control--next' : '.slideshow-control--previous');
      acc = 0;
      cooldownUntil = Date.now() + 450;
      btn?.click();
    }
  }, { passive: false });
})();

// ---------- varyant değişimi: SKU canlı güncelle + ATC watchdog (r32) ----------
// morph, item-meta'daki SKU'yu her zaman tazelemiyor; ayrıca hızlı ardışık
// değişimlerde buton [disabled] snapshot'ında takılı kalabiliyor.
const afoVariantAvailable = () => {
  const sels = [...document.querySelectorAll('.variant-option__select')];
  return sels.length === 0 || sels.every((s) => !/Unavailable/i.test(s.selectedOptions[0]?.text || ''));
};

document.addEventListener('change', (e) => {
  if (!e.target.matches('.variant-option__select')) return;
  // qa1: vid morph'la ~300-600ms'de güncellenir — 2 sabit timeout yerine 150ms'lik
  // poll; değişimi görür görmez yazar (eski 1.6s gecikme "değişmiyor" sanılıyordu)
  const startVid = document.querySelector('input[ref=variantId]')?.value;
  let kalan = 20;
  const tick = () => {
    const meta = document.querySelector('.afo-pp-itemmeta');
    const vid = document.querySelector('input[ref=variantId]')?.value;
    if (meta && vid && meta.dataset.afoSkus) {
      try {
        const sku = JSON.parse(meta.dataset.afoSkus)[vid];
        const el = meta.querySelector('.afo-pp-itemmeta__sku');
        if (sku && el && !el.textContent.endsWith(': ' + sku)) el.textContent = el.textContent.replace(/:\s*.*$/, ': ' + sku);
        if (vid !== startVid) return; // hedefe yazıldı — dur
      } catch {}
    }
    if (--kalan > 0) setTimeout(tick, 150);
  };
  setTimeout(tick, 150);
});

// qa1: bordo bardaki fiyat da "Add to cart"ın parçası — tıklayınca sepete ekler
// (yalnız ATC barındaki product-price; öneri kartlarındaki fiyatlara dokunma)
document.addEventListener('click', (e) => {
  const price = e.target.closest('.product-details product-price');
  if (!price || !price.parentElement) return;
  // teklifle satılan üründe ATC gizli ama DOM'da — fiyat tıklaması sessizce sepete
  // eklemesin, bardaki quote butonuna gitsin
  const quote = price.parentElement.querySelector(':scope .afo-quote-cta__button');
  if (quote) return quote.click();
  const btn = price.parentElement.querySelector(':scope add-to-cart-component .add-to-cart-button');
  if (btn) btn.click();
});

// r34: KALICI watchdog — morph, enable adımını bazen kopmuş eski butona uyguluyor,
// yeni buton [disabled] takılı kalıyor (soluk görünüm). Attribute gözlemcisi:
// disabled 800ms'den uzun kalır ve seçili varyant mevcutsa kaldır.
(() => {
  let timer = null;
  const arm = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const btn = document.querySelector('.add-to-cart-button');
      if (btn && btn.disabled && afoVariantAvailable()) btn.removeAttribute('disabled');
    }, 800);
  };
  const root = document.querySelector('.product-information')?.closest('.shopify-section');
  if (!root) return;
  new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'attributes' && m.target.classList?.contains('add-to-cart-button')) { arm(); return; }
      if (m.type === 'childList') {
        const btn = document.querySelector('.add-to-cart-button');
        if (btn?.disabled) { arm(); return; }
      }
    }
  }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
})();

// ---------- Care & Notes: tek açık + yumuşak animasyon (r25-r26) ----------
// Native details toggle'ı devre dışı: open hep açık kalır, görünürlük
// grid-template-rows 0fr→1fr geçişiyle yönetilir (mobil drawer deseni).
(() => {
  const rows = [...document.querySelectorAll('details.afo-pp-care__row')];
  if (!rows.length) return;
  rows.forEach((row) => {
    const body = row.querySelector('.afo-pp-care__body');
    if (!body || row.querySelector('.afo-pp-care__wrap')) return;
    const wrap = document.createElement('div');
    wrap.className = 'afo-pp-care__wrap';
    body.parentElement.insertBefore(wrap, body);
    wrap.appendChild(body);
    if (row.open) row.classList.add('is-open');
    row.setAttribute('open', ''); // içerik daima render — animasyon CSS'te
    const summary = row.querySelector('summary');
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', String(row.classList.contains('is-open')));
    summary.addEventListener('click', (e) => {
      e.preventDefault(); // native aç/kapa yok
      const willOpen = !row.classList.contains('is-open');
      rows.forEach((r) => {
        r.classList.toggle('is-open', r === row && willOpen);
        r.querySelector('summary').setAttribute('aria-expanded', String(r === row && willOpen));
      });
    });
  });
})();
